module.exports = __webpack_public_path__ + "img/step-3.b8370531.jpg";